export const tr = {
    'auth-as': 'Kimlik doğrulandı:',
    'bd-config': 'Veri tabanı yapılandırması',
    'beta-number': 'Beta numarası',
    'disable-captcha': 'Güvenlik resmini devre dışı bırak',
    'dump-vars': "Dump_vars'ı etkinleştir",
    'fake-auth': 'Sahte kimlik doğrulama',
    features: 'Features list',
    role: 'Rol',
    shard: 'Shard'
};
